import { CSSProperties, useEffect, useRef } from 'react';
import { useIsVisible } from 'shared/visibility_context/VisibilityContext';

export type VisibilityTriggerProps = Readonly<{
    onChange: (isVisible: boolean) => void;
    className?: string;
    style?: CSSProperties;
}>;

export function VisibilityTrigger({
    onChange,
    className,
    style,
}: VisibilityTriggerProps) {
    const ref = useRef<HTMLDivElement>(null);
    const isVisible = useIsVisible(ref);

    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    useEffect(() => {
        onChangeRef.current(isVisible);
    }, [isVisible]);

    return <div ref={ref} className={className} style={style} />;
}
